
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppCommonModule } from '../common.module';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
  ],
})
export class PrivacyComponent {

}
